import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {AuthUserService} from "../../@shared/services/auth/auth-user.service";
import {map, tap} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(private authUserService: AuthUserService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authUserService.user$.pipe(
      map((user: any) => user.roles.some((role: string) => route.data.roles.includes(role))),
      tap((access: boolean) => {
        if (!access) this.router.navigate(['/']);
      }),
    )
  }
}
